import { Capacitor } from "@capacitor/core";
export function GetAssetUri(path) {
    const platform = Capacitor.getPlatform();
    if (platform !== "web") {
        return `${window.argonBaseUrl}${path}`;
    }
    return path;
}
